<template>
  <div class="app-wrapper" :class="[$store.getters.sidebarOpened ? 'openSidebar' : 'hideSidebar']">
    <!--顶部导航-->
    <div class="fixed-header">
        <navbar />
    </div>

    <div class="app-main-container">
      <!--内容区-->
      <app-main> </app-main>
      <Bottom />
    </div>
  </div>
</template>

<script setup>
import Navbar from './components/Navbar.vue'
import AppMain from './components/AppMain.vue'
import Bottom from './components/Bottom.vue'

import {} from 'vue'

</script>

<style lang="scss" scoped>
// @import '~@/styles/mixin.scss';

.app-main-container {
    min-height: 100%;
    //transition: margin-left #{$mainLeftWidth};
    //margin-left: $mainLeftWidth;
    position: relative;
  overflow: auto;
  min-width: 1200px;
  background: rgb(202, 231, 245);
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1000;
  width: 100%; //calc(100% - #{$sideBarWidth})
  transition: width #{$sideBarDuration};
}
</style>
